<template>
    <!--成为买家-->
    <div class="buygb">
        <div class="buyl">
            <h4>买家权益</h4>
            <ul>
                <li>
                    只要您是合法经营的药店或诊所，在药聚多注册并认证后，<br>
                    可以享受以下服务：
                    <br>
                    <span class="blue1"><img src="@/assets/quan.png" style="width:15px;height:15px;">&nbsp;&nbsp;</span>在平台上购买合法经营的卖家出售的合法正规药品<br>
                    <span class="blue1"><img src="@/assets/quan.png" style="width:15px;height:15px;">&nbsp;&nbsp;</span>获得平台的活动补贴<br>
                    <span class="blue1"><img src="@/assets/quan.png" style="width:15px;height:15px;">&nbsp;&nbsp;</span>参与商家的促销活动<br>
                </li>
            </ul>
        </div>
        <reg-view name="买家"></reg-view>
        <div class="clear"></div>
    </div>
</template>
<script>
import RegView from './components/RegView.vue'
export default {
  name: 'Buyer',
  components: { RegView }
}
</script>
